import { Tag } from "antd";
import React from "react";

const ContractStatusTag = ({ contractStatu, ...props }) => {
  switch (contractStatu) {
    case "ACTIVE":
      return <Tag color="green">Etkin</Tag>;
    case "ABOLISH":
      return <Tag color="volcano">Feshedildi</Tag>;
    case "ENDED":
      return <Tag color="gray">Sonlandı</Tag>;
    default:
      return null;
  }
};

export default ContractStatusTag;
